import React from "react";
import { useCurrentDevRate } from "../hooks/useCurrentDevRate";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const CompanyLinkTemplate = (props) => {
  // console.log(props);

  //   const { devRate, isExpired } = useCurrentDevRate(props?.id);
  return (
    <div
    //   style={{
    //     color: isExpired ? "red" : null,
    //     fontWeight: isExpired ? "bold" : null,
    //   }}
    >
      {/* ${devRate ?? 0}
       */}
      <a
        href={`https://sprytelabs.com/partners/${props?.vendorSlug}`}
        target="_blank"
        rel="noreferrer"
        style={{
          textDecoration: "none",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          color: "#0057b3b7",
        }}
      >
        <OpenInNewIcon />
      </a>
    </div>
  );
};

export default CompanyLinkTemplate;
